$(function($) {
    "use strict";

    $('.module-accos').each(function() {
        var $module = $(this);

        var $list = $module.find(".acco-list");
        var $accos = $list.children();

        //variables
        var $btnResetFilter = $module.find(".btn-reset-filter");
        var $btnFilterMobile = $module.find(".btn-filter-mobile");
        var $accosFilter = $module.find('.accosFilter');
        var $filterFlyingblock = $module.find('.filter-flyingblock');
        var $filterFlyingblockMobile = $module.find(".filter-flyingblock-mobile-base");
        var $filterClose = $module.find('.filter-close');
        var $btnFilterNow = $module.find('.btn-filter-now');
        var $mobilSelects = $module.find('.mobil-selects');
        var $dropdownsPc = $module.find('.dropdownsPc');
        var $btnDropRegions = $module.find(".btn-drop-regions");
        var $btnDropThemes = $module.find(".btn-drop-themes");

        var $iconExpandMoreRegions = $module.find(".expandMoreRegions");
        var $iconExpandMoreThemes = $module.find(".expandMoreThemes");
        var $regionLink = $module.find(".regionLink");
        var $themeLink = $module.find(".themeLink");

        //filter-reset
        var $checkbox = $module.find(".dropdown-filter input[type=checkbox]");

        var filter = { amenityIds: [], stars: [], boardingIds: [], page: 1};
        try {
            var json = getCookie("AccosFilter");
            filter = Object.assign(filter, JSON.parse(json));
            if (typeof filter.stars[0] !== 'object') filter.stars = []; // <- this line fixes legacy values in cookie! TODO remove this legacy compatibility code after 26.07.2022
        } catch (e) {
            //ignore
        }
        filterlist(filter.page);
        //filter PC
        $module.find(".dropdown-filter-stars .dropdown-filter-content input[type=checkbox]").on('change',
            function () {
                var $input = $(this);
                var value = $input.val();
                var splitStars = value.split("-");
                if ($input.prop("checked")) {
                    filter.stars.push({
                        value: value,
                        from: +splitStars[0],
                        to: +splitStars[1],
                    });

                } else {
                    filter.stars = filter.stars.filter(function (x) {
                        return x.value !== value;
                    });
                }
                if ($(window).width() >= 767) {
                    filterlist(filter.page);
                }
                refreshCount();
            });
        $module.find(".dropdown-filter-stars .dropdown-filter-content input[type=checkbox]").each(function() {
            var idStars = $(this).attr('value');
            var checkbox = $(this);
            filter.stars.forEach(function(x) {
                if (x.value == idStars) {
                   checkbox.prop("checked", true);
                }
            });
        });

        $module.find(".dropdown-filter-amenities .dropdown-filter-content input[type=checkbox]").each(function () {
            var idEquiptments = $(this).attr('value');
            if (filter.amenityIds.includes(idEquiptments)) {
                $(this).prop("checked", true);

            } else {
                $(this).prop("checked", false);
            }
            $(this).on('change',
                function() {
                    var $input = $(this);
                    var value = $input.val();
                    if ($input.prop("checked")) {
                        filter.amenityIds.push(value);
                    } else {
                        const index = filter.amenityIds.indexOf(value);
                        if (index > -1) {
                            filter.amenityIds.splice(index, 1); //after clicking, all accos come back
                        }
                    }
                    if ($(window).width() >= 767) {
                        filterlist(filter.page);
                    }

                    refreshCount();
                });
        });
        $module.find(".dropdown-filter-amenities .dropdown-filter-content label[name=checkbox]").each(function () {
            var idEquiptments = $(this).attr('value');
            if (filter.amenityIds.includes(idEquiptments)) {
                $(this).parents(".equiptCheckbox").prepend($(this));
                $(this).show();
            }
        });
        $module.find(".accos-filter-boardings input[type=checkbox]").each(function () {
            var idBoardings = $(this).attr('value');
            if (filter.boardingIds.includes(idBoardings)) {
                $(this).prop("checked", true);
            } else {
                $(this).prop("checked", false);
            }
            $(this).on('change',
                function () {
                    var $input = $(this);
                    var value = $input.val();
                    if ($input.prop("checked")) {
                        filter.boardingIds.push(value);
                    } else {
                        const index = filter.boardingIds.indexOf(value);
                        if (index > -1) {
                            filter.boardingIds.splice(index, 1); //after clicking, all accos come back
                        }
                    }
                    if ($(window).width() >= 767) {
                        filterlist(filter.page);
                    }
                    refreshCount();
                });
        });
        function filterlist(page) {
            $list.html('');
            var filterAccos = [];

            $accos.each(function () {
                var $acco = $(this);
                var amenityIds = $acco.data("amenityids").toString().split(',');
                var accoStars = $acco.data("stars");
                var boardingIds = $acco.data("boardingids").toString().split(',');
                var foundAmenityIds = 0;
                filter.amenityIds.forEach(function(x) {
                    var success = false;
                    amenityIds.forEach(function(y) {
                        if (x === y) {
                            success = true;
                        }
                    });

                    if (success) {
                        foundAmenityIds++;
                    }
                });

                function checkStar(star) {
                    return star.from <= accoStars && accoStars <= star.to;
                }
                function checkBoard(board) {
                    return filter.boardingIds.includes(board) && boardingIds.includes(board);
                }

                var matchStars = filter.stars.some(checkStar) || filter.stars.length === 0;
                var matchAmenities = filter.amenityIds.length === foundAmenityIds;
                var matchBoardings = filter.boardingIds.some(checkBoard)|| filter.boardingIds.length === 0;
                if (matchStars && matchAmenities && matchBoardings) {
                    filterAccos.push($acco);
                }
            });
            var totalCount = filterAccos.length;
            updatePaging(totalCount, page);
            var pageSize = 15;
            var take = pageSize;
            var skip = (page - 1) * pageSize;
            var pageAccos = filterAccos.slice(skip, skip + take);
            pageAccos.forEach(function (acco) {
                $list.append(acco.show());
            });
            window.CreateSlider();
            window.bindGaq($list);
            refreshCount();
            $list.children().length ? $module.find(".error").css("display", "none") : $module.find(".error").css("display", "block");

            //- -------------------enquirybar-----------------------------
            $(".enquirybar input[name=AmenityIds]").val(filter.amenityIds.join(","));
            var valueStar = filter.stars.map(function (val) { return val.value; });
            $(".enquirybar input[name=Stars]").val(valueStar);
            $(".enquirybar input[name=BoardingIds]").val(filter.boardingIds.join(","));
            //- -----------------------cookie-----------------------------

            const object = { amenityIds: filter.amenityIds, stars: filter.stars, boardingIds: filter.boardingIds}

            var json = JSON.stringify(object);
            try {
                setCookie("AccosFilter", json, 1);
            } catch (e) {
                console.log(e);
            }
        }


        //btn reset
        $btnResetFilter.on('click',
            function() {
                filter.stars = [];
                filter.amenityIds = [];
                filterlist(filter.page);
                $checkbox.prop('checked', false);
            });

        //Filter-mobile
        $btnFilterMobile.on('click',
            function () {
                $accosFilter.show();
                $filterFlyingblock.show();
                $filterFlyingblockMobile.show();
                $module.find(".region-dropdown").hide();
                $module.find(".theme-dropdown").hide();
                $mobilSelects.show();
                $('body').css("overflow", "hidden");
                $accosFilter.css("overflow", "auto");
            });

        //filter-close
        $filterClose.on('click',
            function () {
                $accosFilter.hide();
                $filterFlyingblock.hide();
                $dropdownsPc.show();
                $mobilSelects.hide();
                $('body').css("overflow", "auto");
                $accosFilter.css("overflow", "hidden");
            });

        //window-resize
        //$(window).on('resize',
        //    function() {
        //        var win = $(this);
        //        if (win.width() >= 768) {
        //            $accosFilter.show();
        //            $filterFlyingblock.hide();
        //        }
        //        if (win.width() >= 768) {
        //            $filterFlyingblock.show();
        //            $accosFilter.show();
        //        }
        //    });

        // --- Button dropdowns ---
        //regions
        $(document).ready(function ($) {
            var open = false;
            var openSidebar = function () {
                $('.dropdown-filter-regions').addClass('is-active');
                $iconExpandMoreRegions.addClass("rotate");
                open = true;
            }
            var closeSidebar = function () {
                $('.dropdown-filter-regions').removeClass('is-active');
                $iconExpandMoreRegions.removeClass("rotate");
                open = false;
            }

            $btnDropRegions.click(function (event) {
                event.stopPropagation();
                var toggle = open ? closeSidebar : openSidebar;
                toggle();
            });

            $iconExpandMoreRegions.click(function (event) {
                event.stopPropagation();
                var toggle = open ? closeSidebar : openSidebar;
                toggle();
            });

            $(document).click(function (event) {
                if (!$(event.target).closest('.drodown-filter-regions').length) {
                    closeSidebar();
                }
            });
        });
        //themes
        $(document).ready(function ($) {
            var open = false;
            var openSidebar = function () {
                $('.dropdown-filter-themes').addClass('is-active');
                $iconExpandMoreThemes.addClass("rotate");
                open = true;
            }
            var closeSidebar = function () {
                $('.dropdown-filter-themes').removeClass('is-active');
                $iconExpandMoreThemes.removeClass("rotate");
                open = false;
            }

            $btnDropThemes.click(function (event) {
                event.stopPropagation();
                var toggle = open ? closeSidebar : openSidebar;
                toggle();
            });

            $iconExpandMoreThemes.click(function (event) {
                event.stopPropagation();
                var toggle = open ? closeSidebar : openSidebar;
                toggle();
            });

            $(document).click(function (event) {
                if (!$(event.target).closest('.drodown-filter-themes').length) {
                    closeSidebar();
                }
            });
        });

        // .dropdown-filter - open/close
        $module.find('.dropdown-filter').each(function () {
            var $btn = $(this).find('.icon-chevron');
            var $content = $(this).find('.dropdown-filter-content');

            $(this).find('.dropdown-filter-text, .icon-chevron').on('click', function () {
                $content.animate({ height: "toggle" }, { duration: 500, easing: 'swing' });
                $btn.toggleClass("rotate");
            });
        });


        // select one region or theme
        $module.find(".regionOption select[name=regionMobilId]").on("change",
            function() {
                $module.find("#themeMobilId").val(0);
            });
        $module.find(".themeOption select[name=themeMobilId]").on("change",
            function() {
                $module.find("#regionMobilId").val(0);
            });

        //btn-filter-now
        if ($(window).width() <= 767) {
            var link = "";
            $module.find(".regionOption select[name=regionMobilId]").on("change",
                function() {
                    link = $(this).find(':selected').data('url');
                    refreshCount();
                });
            $module.find(".themeOption select[name=themeMobilId]").on('change',
                function() {
                    link = $(this).find(':selected').data('url');
                    refreshCount();
                });

            $btnFilterNow.on('click',
                function() {
                    $('body').css("overflow", "auto");
                    $accosFilter.css("overflow", "hidden");
                    $accosFilter.hide();
                    $filterFlyingblockMobile.hide();
                    $filterFlyingblock.hide();
                    if (link == "") {
                        filterlist(filter.page);
                    } else {
                        filterlist(filter.page);
                        location.href = link;
                    }
                });
        }

        // show more Button

        // TODO create [showmore] directive component!
        $module.find('.dropdown-filter-amenities .dropdown-filter-content').each(function() {
            var $module = $(this);

            var $btn = $module.find('[showmore-btn]');

            var $container = $module.find('[showmore-items]');
            var maxCount = +$btn.attr('showmore-btn');

            $btn.click(function() {
                var count = 0;
                var all = $container.children();
                all.each(function() {
                    var e = $(this);
                    if (!e.is(":visible")) {
                        if (count < maxCount) {
                            e.show();
                        }
                        count++;
                    }
                });
                if ($container.find(">:visible").length === all.length) {
                    $btn.hide();
                }
            });
        });
        //btn-booking
        //$btnBooking.each(function() {
        //    var href = $(this).prop('href');
        //    if (href.indexOf('?') > -1) {
        //        $btnBooking.show();
        //    } else {
        //        $btnBooking.hide();
        //    }
        //});

        // paging
        function updatePaging(totalCount, pageNumber) {
            var pageSize = 15;
            var pageCount = (parseInt(Math.ceil(totalCount)) / parseFloat(pageSize));

            var pagination = $module.find(".pagination").html("");
            for (var i = 1; i <= Math.ceil(pageCount); i++) {
                addPaging(i);
            }
            var aElement;
            function addPaging(page) {
                if (pageCount > 1) {
                    aElement = $('<a href="#accos" value=' + page + '>' + page + '</label>').on("click",
                        function() {
                            filterlist(page);
                        });
                if (page == pageNumber) {
                    aElement.addClass("active");
                }

                pagination.append(aElement);
                }
            }
        }

        //$(window).on("load", function () {
        //    refreshCount();
        //});

        function loading(isLoading) {
            // TODO fix loading spinner !!! it doesn't work!
            $module.find('.load-spinner').toggleClass('spin', isLoading);
            $module.find(':submit').prop('disabled', isLoading);
            $module.find('.accos-count b').hide();
        }

        var oneCompanyCount = $(".filter-companycount span1");

        function refreshCount() {
            var areaId, themeId;
                areaId = parseInt($(".regionsNav").filter(".active").attr("id")) || 0;
                themeId = parseInt($(".themesNav").filter(".active").attr("id")) || 0;
            // fix (undefined | "" | string | string[]) to string[]
            var makeArray = function (value) { return !$.isArray(value) && value ? [value] : value || []; }

            var accosFilter = {
                themeId: themeId,
                areaId: areaId,
                stars: makeArray(filter.stars),
                boardingIds: makeArray(filter.boardingIds),
                amenityIds: makeArray(filter.amenityIds)
            };

            loading(true);
            $.ajax({
                cache: false,
                url: '/api/accos/count',
                type: 'POST',
                data: JSON.stringify(accosFilter),
                dataType: 'json',
                contentType: 'application/json',
                success: function(data) {
                    setTimeout(timeout, 300);
                    function timeout() {
                        loading(false);
                        var count = data.count;
                        $("#enquiry-small-box-send b").addClass("count");
                        $(".count").html(count);

                        $module.find(".accos-count").html("<b>" + count + "</b>");
                        $module.find('.accos-count b').show();
                        if (count == 1) {
                            $module.find(".filter-companycount span").hide();
                            $module.find(".accos-count b").html(count) && oneCompanyCount.show();
                            $module.find('.accos-count b').show();
                        } else {
                            $module.find(".filter-companycount span").show();
                            oneCompanyCount.hide();
                        }
                        if (count == 0) {
                            $module.find(".errorFilter").show();
                            $module.find($btnFilterNow).hide();
                            $(".date-picker__position button").css("opacity", "0.7").attr("disabled", true);

                        } else {
                            $module.find(".errorFilter").hide();
                            $module.find($btnFilterNow).show();
                            $(".date-picker__position button").attr("disabled", false);
                            $(".date-picker__position button").css("opacity", "1");
                        }
                    }
                }
            });
        }

    });


    function getCookie(name) {
        var i,
            x,
            y,
            cookies = document.cookie.split(";");

        for (i = 0; i < cookies.length; i++) {
            x = cookies[i].substr(0, cookies[i].indexOf("="));
            y = cookies[i].substr(cookies[i].indexOf("=") + 1);
            x = x.replace(/^\s+|\s+$/g, "");

            if (x === name) {
                return unescape(y);
            }
        }
    }

    function setCookie(name, value, exdays) {
        var cookieValue = escape(value);
        if (exdays) {
            var exdate = new Date();
            exdate.setDate(exdate.getDate() + exdays);
            cookieValue += "; expires=" + exdate.toUTCString();
        }
        document.cookie = name + "=" + cookieValue + "; path=/";
    }
});